import React from 'react';

const BasicIndexContext = React.createContext();

export const IndexItems = () => {
  return (
    <BasicIndexContext.Consumer>
      {context => {
        const { indexItems, indexItemRenderer, canViewUserDetails, isMobile } = context;
        return indexItems.map((indexItem, idx) =>
          indexItemRenderer(indexItem, idx, canViewUserDetails, isMobile)
        );
      }}
    </BasicIndexContext.Consumer>
  );
};

const BasicIndex = ({ indexItems, indexItemRenderer, canViewUserDetails, className, children }) => {
  return (
    <BasicIndexContext.Provider
      value={{
        indexItems: indexItems,
        indexItemRenderer: indexItemRenderer,
        canViewUserDetails: canViewUserDetails
      }}
    >
      <div className={className ? className : 'indexItems'}>{children}</div>
    </BasicIndexContext.Provider>
  );
};

export default BasicIndex;
